
































import store from '@/store'
import ApiClient from '@/js/api.js'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import Zipcode from '@/views/molecules/Zipcode.vue'

export default
  name: 'AddSender'

  components: {
    TextBox
    ErrorLabel
    SelectBox
    YellowButton
    BackButton
    ManageRow
    ManageTemplate
    Zipcode
  }

  data: () ->
    memberData: {}
    prefList: {}
    prefID: '0'
    prefValue: ''

  created: () ->
    @prefList = await store.getters.prefList

  computed: {
    isDetailChange: () ->
      @prefID = store.getters.getPostParam.prefecture_id
      return store.getters.isSetDetail
  }

  methods: {
    go_back: (e) ->
      @$emit('go_back')
    search_address: (address) ->
      @prefID = address.pref_id + ''
      @prefValue = address.shiku_name + address.choiki_name
    execute_append_send: (e) ->
      api = new ApiClient()
      data = await api.post('/member/sendplace/save')
      if data.errors.length == 0
        url = await store.getters.backURL
        if url
          @$router.push url
        else
          @$router.push '/mypage'
  }
